<template>
  <div class="list-empty">
    <svg-icon
      class="empty-icon"
      href="#list-empty"
      :width="60"
      :height="60"
    ></svg-icon>
    <div class="empty-label">
      <slot name="content">
        {{$t("message.info_list_empty")}}
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "list-empty"
};
</script>
<style lang="scss">
.list-empty {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .empty-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-30px, -60px);
    fill: #696969;
  }
  .empty-label {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    text-align: center;
    color: #696969;
    font-size: 16px;
    letter-spacing: 0.2em;
    line-height: 48px;
  }
}
</style>
